import Vuex from 'vuex'
import Vue from 'vue'
import app from "./modules/app";
import order from "./modules/order";

Vue.use(Vuex);



export default new Vuex.Store({
  modules:{
    app,
    order
  },
})


